import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import Select from 'react-select';
import { css } from "styled-components/macro"; //eslint-disable-line
import Noimg from "../images/no_img.jpg";
import { getProduct, orderStatus } from "../api/ProductApi.js";
import { currentRegister } from "utility/Constant.js";
import { Link, useNavigate } from "react-router-dom";
import ProductCommon from "../components/ProductLike&Wish";
import no_data from "images/no_data.png";
import SkeletonLoader from "components/SkeletonLoader";
import { getBranchId } from "utility/HeaderConfig";

const Container = tw.div`relative font-display overflow-hidden`;
const TabContent = tw(motion.div)`block`;

function ProductCard({ categoryItem, onClick }) {
  const [hov, setHov] = useState(false);
  const imgSrc = categoryItem.images === '@#@' ? Noimg : categoryItem.images.split('@#@')[0];

  return (
    <div
      style={{
        background: '#fff', borderRadius: 16, overflow: 'hidden',
        boxShadow: hov ? '0 8px 32px rgba(110,54,201,0.18)' : '0 2px 12px rgba(80,40,130,0.08)',
        border: '1px solid var(--red-200)', cursor: 'pointer',
        transform: hov ? 'translateY(-4px)' : 'none',
        transition: 'box-shadow 0.25s, transform 0.25s',
        display: 'flex', flexDirection: 'column', height: '100%',
      }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onClick}
    >
      <div style={{ position: 'relative', overflow: 'hidden', aspectRatio: '1 / 1', background: 'var(--surface-cream)' }}>
        <img
          src={imgSrc} alt={categoryItem.category}
          style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s', transform: hov ? 'scale(1.07)' : 'scale(1)' }}
        />
        {categoryItem.stockStatus === 'Sale' && (
          <span style={{
            position: 'absolute', top: 10, left: 10,
            background: 'linear-gradient(135deg,#b8860b,#c9a34d)',
            color: '#fff', fontSize: 9, fontWeight: 700, letterSpacing: '.07em',
            padding: '3px 10px', borderRadius: 20, textTransform: 'uppercase',
          }}>Available</span>
        )}
        {/* Exclusive badge */}
        <span style={{
          position: 'absolute', top: 10, right: 10,
          background: 'linear-gradient(135deg,#c9a34d,#c9a34d)',
          color: '#fff', fontSize: 8, fontWeight: 800, letterSpacing: '.1em',
          padding: '3px 8px', borderRadius: 20, textTransform: 'uppercase',
        }}>✦ Exclusive</span>
      </div>
      <div style={{ padding: '14px 16px 16px', flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <p style={{ margin: 0, fontSize: 11, color: 'var(--red-500)', textTransform: 'uppercase', letterSpacing: '.06em' }}>
          {categoryItem.metalType}
        </p>
        <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: 'var(--red-900)', lineHeight: 1.3,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={categoryItem.title}>
          {categoryItem.category}
        </p>
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--gold-400)' }}>
            ₹{Math.trunc(categoryItem.total).toLocaleString('en-IN')}
          </span>
          {categoryItem.goldPurity && categoryItem.goldPurity !== '-' && (
            <span style={{ fontSize: 10, color: 'var(--red-500)', background: 'var(--surface-cream)',
              padding: '2px 8px', borderRadius: 10, border: '1px solid var(--red-200)' }}>
              {categoryItem.goldPurity}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ({ configImages }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderStatusSale, setOrderStatusSale] = useState("");
  const [orderStatusTransfer, setOrderStatusTransfer] = useState("");
  const [orderStatusSold, setOrderStatusSold] = useState("");
  const [selectedOption, setSelectedOption] = useState({ id: 4, label: 'SHOP OUR EXCLUSIVE', value: '/ShopOurExclusiveComponent' });

  const pageList = [
    { id: 1, label: 'NEW ARRIVALS', value: '/NewArrivals' },
    { id: 2, label: 'MOST LIKED PRODUCT', value: '/MostLiked' },
    { id: 3, label: 'TREND ON SHOPS', value: '/TrendOnShopComponent' },
    { id: 4, label: 'SHOP OUR EXCLUSIVE', value: '/ShopOurExclusiveComponent' },
    { id: 5, label: 'BEST SELLING', value: '/BestSellingComponent' },
  ];

  const history = useNavigate();

  useEffect(() => {
    Promise.all([getOrderStatusSale(), getOrderStatusTransfer(), getOrderStatusSold()])
      .then((result) => getShopOurExclusive(result[0], result[1], result[2]))
      .catch((err) => console.error(err));
    //eslint-disable-next-line
  }, []);

  const getOrderStatusSale = () => orderStatus({ orderStatusName: "sale" }).then((d) => { setOrderStatusSale(d.response[0].id); return d.response[0].id; }).catch(console.error);
  const getOrderStatusTransfer = () => orderStatus({ orderStatusName: "Transferred" }).then((d) => { setOrderStatusTransfer(d.response[0].id); return d.response[0].id; }).catch(console.error);
  const getOrderStatusSold = () => orderStatus({ orderStatusName: "Sold" }).then((d) => { setOrderStatusSold(d.response[0].id); return d.response[0].id; }).catch(console.error);

  const getShopOurExclusive = (sale, transfer, sold) => {
    setLoading(true);
    if (sale && transfer && sold) {
      getProduct(2000, {
        branch: getBranchId(), productLabel: 'Shop Our Exclusives',
        removeNTP: "NTP-", removeHP: "HP-",
        beforeCreatedAt: currentRegister(), sortType: true,
        demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
        statusId: `${sale},${transfer},${sold}`,
      })
        .then((data) => { setCategoryList(data.response.content); setLoading(false); })
        .catch(console.error);
    }
  };

  const handleMenuItemClick = (menuItem) => { setSelectedOption(menuItem); history(`${menuItem.value}`); };

  return (
    <Container>
      <div style={{ background: 'var(--surface-cream)', borderBottom: '1px solid var(--red-200)', padding: '12px 24px' }}>
        <div style={{ fontSize: 12, color: 'var(--red-500)' }}>
          <Link to="/" style={{ color: 'var(--red-500)', textDecoration: 'none' }}>HOME</Link>
          <span style={{ margin: '0 6px' }}>›</span>
          <span style={{ color: 'var(--gold-400)', fontWeight: 600 }}>SHOP OUR EXCLUSIVES</span>
        </div>
      </div>

      <div style={{ padding: '32px 16px 64px', position: 'relative' }}>
        <div className="container">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16, marginBottom: 28 }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--red-900)', letterSpacing: '-.01em' }}>
                Shop Our Exclusives
              </h2>
              <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--red-500)' }}>
                {loading ? '...' : `${categoryList.length} exclusive pieces`}
              </p>
            </div>
            <div style={{ minWidth: 220 }}>
              <Select
                options={pageList}
                value={selectedOption}
                onChange={handleMenuItemClick}
                styles={{
                  control: (b) => ({ ...b, borderColor: 'var(--red-200)', borderRadius: 10, fontSize: 13 }),
                  option: (b, s) => ({ ...b, fontSize: 13, background: s.isSelected ? 'var(--gold-400)' : s.isFocused ? 'var(--surface-cream)' : '#fff', color: s.isSelected ? '#fff' : 'var(--red-900)' }),
                }}
              />
            </div>
          </div>

          {categoryList.length === 0 && !loading ? (
            <img src={no_data} alt="no-data" style={{ display: 'block', margin: '60px auto', maxWidth: 280 }} />
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: 20 }}>
              {categoryList.map((categoryItem, index) => (
                <TabContent key={index} transition={{ duration: 0.3 }} style={{ position: 'relative' }}>
                  <ProductCommon categoryItem={categoryItem} />
                  <ProductCard
                    categoryItem={categoryItem}
                    onClick={() => history(`/ProductDetails/${categoryItem.id}`, { state: { categoryItem } })}
                  />
                </TabContent>
              ))}
            </div>
          )}

          {loading && <SkeletonLoader />}

          {!loading && categoryList.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
              <button
                onClick={() => getShopOurExclusive(orderStatusSale, orderStatusTransfer, orderStatusSold)}
                style={{ padding: '12px 40px', borderRadius: 30, border: '1.5px solid var(--gold-400)', background: 'transparent', color: 'var(--gold-400)', fontWeight: 700, fontSize: 13, letterSpacing: '.06em', cursor: 'pointer', transition: '0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--gold-400)'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--gold-400)'; }}
              >VIEW MORE</button>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};